import React, { useEffect, useState } from "react";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../constants/Contract";
import "../../../../assets/stylesheets/ConfidentialApplication/ConfidentialApplication.scss";
import ConfProfessionalDesignations from "./ConfProfessionalDesignations";

function ConfEducation({
  education,
  toggleForm,
  form_id,
  contracttypeid,
  contracttype,
  eduDegrees,
  eduLevels,
  pDesignations,
  isConfidential,
  cria,
}) {
  const [highSchoolDetails, setHighSchoolDetails] = useState({});
  const [collegeEducationDetails, setCollegeEducationDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [educationHistory, setEducationHistory] = useState([]);
  const { professionalDesignations, hasprofdesignation } = pDesignations;

  let pageSize = 5;
  let totalPage = Math.ceil(collegeEducationDetails.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const parseMonthYear = (str) => {
    if (str === null || str === "") return Date.now();
    if (!str) return "";
    const [month, year] = str?.split("/").map(Number);
    return new Date(year, month - 1);
  };

  let currentItems = [...collegeEducationDetails].sort(
    (a, b) => parseMonthYear(b.enddate) - parseMonthYear(a.enddate)
  );

  if (!isConfidential) {
    currentItems = currentItems.slice(startIndex, startIndex + pageSize);
  }

  const handleNext = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    setCurrentPage((prev) => prev - 1);
  };
  useEffect(() => {
    const educationHistory = formatEducationData(
      education,
      eduLevels,
      eduDegrees
    );
    setEducationHistory(educationHistory);

    // Separate high school and college details
    const highSchool = educationHistory.find(
      (edu) => edu.educationlevelid === 2
    );
    const college = educationHistory.filter(
      (edu) => edu.educationlevelid !== 2
    );

    setHighSchoolDetails(highSchool || {});
    setCollegeEducationDetails(college);
  }, [education, eduLevels, eduDegrees]);

  return (
    <div id="reviewEducation" className="review-form">
      <div className="col-7 row mm-spacing--minor">
        <h3 id="conf_education">Education</h3>
      </div>

      {(contracttype === CONTRACT_TYPE_DESCRIPTIONS.CAREER_AGENT ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.CAREER_SAMPLING ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.ALTERNATE_AGENT ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS ||
        contracttype === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN ||
        cria) && (
        <div className="candidate-info">
          <div className="row">
            <div
              className={
                form_id === "confidential_education" ? "col-5" : "col-6"
              }
            >
              <strong id="eduHighestLevelLabel">
                What was your last High School attended?*
              </strong>
            </div>
            <div id="eduHighestLevel" className="col-6 bo--text-color">
              {highSchoolDetails !== null
                ? highSchoolDetails.institutionname
                : "-"}
            </div>
          </div>
          <div className="row">
            <div
              className={
                form_id === "confidential_education" ? "col-5" : "col-6"
              }
            >
              <strong id="eduHighestLevelLabel">
                What dates did you attend?*
              </strong>
            </div>
            <div id="eduHighestLevel" className="col-6 bo--text-color">
              {highSchoolDetails !== null
                ? `${highSchoolDetails.startdate} - ${highSchoolDetails.enddate}`
                : "-"}
            </div>
          </div>
          <div className="row">
            <div
              className={
                form_id === "confidential_education" ? "col-5" : "col-6"
              }
            >
              <strong id="eduHighestLevelLabel">City*</strong>
            </div>
            <div id="eduHighestLevel" className="col-6 bo--text-color">
              {highSchoolDetails !== null ? highSchoolDetails.city : "-"}
            </div>
          </div>
          <div className="row">
            <div
              className={
                form_id === "confidential_education" ? "col-5" : "col-6"
              }
            >
              <strong id="eduHighestLevelLabel">
                State/Province
                {highSchoolDetails.country === "US" ? "*" : ""}
              </strong>
            </div>
            <div id="eduHighestLevel" className="col-6 bo--text-color">
              {highSchoolDetails !== null
                ? !highSchoolDetails.state
                  ? "-"
                  : highSchoolDetails.state
                : "-"}
            </div>
          </div>
          <div className="row">
            <div
              className={
                form_id === "confidential_education" ? "col-5" : "col-6"
              }
            >
              <strong id="eduHighestLevelLabel">Country*</strong>
            </div>
            <div id="eduHighestLevel" className="col-6 bo--text-color">
              {highSchoolDetails !== null ? highSchoolDetails.country : "-"}
            </div>
          </div>
          <>
            {contracttype !== CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY && contracttype !== CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR && (
                <ConfProfessionalDesignations
                  designations={professionalDesignations}
                  form_id={form_id}
                />
            )}
          </>
          <div className="row">
            <div
              className={
                form_id === "confidential_education" ? "col-5" : "col-6"
              }
            >
              <strong id="eduHighestLevelLabel">
                Did you attend any institutions after High School?*
              </strong>
            </div>
            <div id="eduHighestLevel" className="col-6 bo--text-color">
              {collegeEducationDetails.length > 0 ? "Yes" : "No"}
            </div>
          </div>
          {contracttype === CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN && (
            <>
              <div className="row">
                <div className="col-5">
                  <strong id="eduEnrolledLabel">
                    Are you currently enrolled full time in college?*
                  </strong>
                </div>
                <div id="eduEnrolled" className="col-6 bo--text-color">
                  {highSchoolDetails?.fulltimeenrolled ? "Yes" : "No"}
                </div>
              </div>
              <div className="row">
                <div className="col-5">
                  <strong id="eduAcademicYearLabel">
                    What academic year are you currently enrolled in?*
                  </strong>
                </div>
                <div id="eduAcademicYear" className="col-6 bo--text-color">
                  {highSchoolDetails?.currentacademicyearid === 1 && "Junior"}
                  {highSchoolDetails?.currentacademicyearid === 2 && "Senior"}
                  {highSchoolDetails?.currentacademicyearid === 3 &&
                    "Graduate Program"}
                </div>
              </div>
            </>
          )}
          {collegeEducationDetails.length > 0 && (
            <>
              <div className="row">
                <div className="col-5" style={{ marginTop: "20px" }}>
                  <strong id="eduEnrolledLabel">
                    Post High School Education
                  </strong>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {collegeEducationDetails.length > 0 && (
                    <>
                      {currentItems.map((institute, index) => {
                        return (
                          <>
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <span
                                style={{
                                  width: "150px",
                                  display: "flex",
                                  overflowWrap: "break-word",
                                  flexDirection: "column",
                                }}
                              >
                                {institute.institutionname}
                                <span>
                                  {institute.city},
                                  {institute.country === "US"
                                    ? institute.state
                                    : institute.country}
                                </span>
                              </span>
                              <span style={{ width: "65px" }}>
                                {institute.startdate}
                              </span>
                              <span style={{ width: "65px" }}>
                                {institute.currentinstitution
                                  ? "Present"
                                  : institute.enddate}
                              </span>
                              <span style={{ width: "200px" }}>
                                {institute.educationdegreedesc
                                  ? institute.educationdegreedesc
                                  : "-"}
                              </span>
                              <span
                                style={{
                                  width: "100px",
                                  overflowWrap: "break-word",
                                  flexDirection: "column",
                                  display: "flex",
                                }}
                              >
                                {institute.major ? institute.major : "-"}
                              </span>
                            </div>
                            {index !== collegeEducationDetails.length - 1 && (
                              <hr />
                            )}
                          </>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default ConfEducation;

function formatEducationData(educationHistory, eduLevels, eduDegrees) {
  return educationHistory.map((item) => {
    const level = eduLevels?.find(
      (l) => l.educationlevelid === item.educationlevelid
    );
    const degree = eduDegrees?.find(
      (d) => d.educationdegreeid === item.educationdegreeid
    );

    return {
      oktasubid: item.oktasubid, // if available, else remove this line
      candidateid: item.candidateid,
      educationlevelid: item.educationlevelid,
      educationleveldesc: level ? level.educationleveldesc : null,
      educationdegreeid: item.educationdegreeid,
      educationdegreedesc: degree ? degree.educationdegreedesc : null,
      major: item.major,
      institutionname: item.institutionname,
      startdate: item.startdate ? item.startdate : item.enrolldate,
      enddate: item.enddate? item.enddate : item.expectgraddate,
      city: item.city,
      state: item.state,
      country: item.country,
      currentinstitution: item.currentinstitution ? item.currentinstitution : item.currentlyattending,
      fulltimeenrolled: item.fulltimeenrolled,
      currentacademicyearid: item.currentacademicyearid,
    };
  });
}